import JSONBigInt from 'json-bigint';

const JSONBigIntAsString = JSONBigInt({ storeAsString: true });

export function isJsonString(str: any): str is string {
  if (typeof str !== 'string') {
    return false;
  }
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function jsonBigIntParse<T>(str: string): T {
  return JSONBigIntAsString.parse(str);
}
